import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { PROCESSO_STATUS, getStatusConfig, getNextStatuses, validateStatusTransition } from './StatusConfig';
import { ChevronDownIcon } from './Icons';
import StatusBadge from './StatusBadge';

const StatusSelector = ({ 
  currentStatus, 
  onStatusChange, 
  tasks = [], 
  disabled = false,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isChanging, setIsChanging] = useState(false);

  const nextStatuses = getNextStatuses(currentStatus);

  const handleStatusChange = async (newStatus) => {
    if (isChanging) return;
    setIsOpen(false);

    // Valida a transição de estado (ex: verifica se há tarefas pendentes)
    const validation = validateStatusTransition(currentStatus, newStatus, tasks);
    if (!validation.valid) {
      toast.error(validation.reason);
      return;
    }

    setIsChanging(true);
    try {
      await onStatusChange(newStatus);
      toast.success('Status atualizado com sucesso!');
    } catch (error) {
      console.error('Erro ao alterar status:', error);
      toast.error('Erro ao alterar status do processo.');
    } finally {
      setIsChanging(false);
    }
  };

  if (nextStatuses.length === 0 || disabled) {
    return <StatusBadge status={currentStatus} />;
  }

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        disabled={isChanging}
        className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
        title="Clique para alterar o status"
      >
        <StatusBadge status={currentStatus} />
        <ChevronDownIcon className={`h-4 w-4 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full right-0 mt-1 z-20 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-48">
            <div className="px-3 py-2 text-xs font-medium text-gray-500 border-b border-gray-100">
              Alterar para:
            </div>

            {nextStatuses.map(status => {
              const config = getStatusConfig(status);
              const validation = validateStatusTransition(currentStatus, status, tasks);

              return (
                <button
                  key={status}
                  onClick={() => handleStatusChange(status)}
                  disabled={!validation.valid || isChanging}
                  className="w-full px-3 py-2 text-left hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-between"
                  title={validation.valid ? config.description : validation.reason}
                >
                  <StatusBadge status={status} showIcon={true} />
                  {!validation.valid && (
                    <span className="text-xs text-red-500 ml-2" title={validation.reason}>
                      ⚠️
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default StatusSelector;